// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1W_Qw","title":"Header_title__DUmRQ","side":"Header_side__3Rb2U"};